/** List users */
export const userListSpec = {
    uri: '/user',
    method: 'POST',
    adminOnly: true,
};
